import { render } from "./search.vue?vue&type=template&id=39f3f68a&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=39f3f68a&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f3f68a"]])

export default __exports__